import React from 'react';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import MediaQuery from 'react-responsive';
import { RadioCards, RadioCard, H2, P, ButtonPrimary } from '@yuhu-inc/yuhui';

import Select from 'components/ui/SelectField';
import { getTranslatedString } from 'helpers/i18n';

const StyledForm = styled(Form)`
  width: 100%;
`;

const StyledInner = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledCardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 5rem;
  margin-bottom: 5rem;
`;

const StyledRadioCard = styled(RadioCard)`
  min-width: 220px;
  width: 30%;
`;

const StyledP = styled(P)`
  margin: 0;
  font-size: 16px;
  font-weight: 800;
`;

const StyledSelect = styled(Select)`
  width: 100%;
`;

const TemplateTypeCard = ({ value, bodyText }) => {
  return (
    <StyledRadioCard value={value}>
      {({ selected }) => <StyledP contentKey={bodyText} centered />}
    </StyledRadioCard>
  );
};

const unitTypesContentKeys = [
  'landlordPortal.inspectionTemplate.unit_type_0',
  'landlordPortal.inspectionTemplate.unit_type_1',
  'landlordPortal.inspectionTemplate.unit_type_2',
  'landlordPortal.inspectionTemplate.unit_type_3',
  'landlordPortal.inspectionTemplate.unit_type_4',
  'landlordPortal.inspectionTemplate.unit_type_5',
  'landlordPortal.inspectionTemplate.unit_type_6',
  'landlordPortal.inspectionTemplate.unit_type_7',
];

const TemplateUnitTypeSchema = Yup.object().shape({
  unit_type: Yup.string().required(),
});

export const AddTemplateUnitTypePage = ({ forward, setTemplate }) => {
  return (
    <Formik
      initialValues={{
        unit_type: undefined,
      }}
      validationSchema={TemplateUnitTypeSchema}
      onSubmit={(values) => {
        setTemplate((template) => {
          return { ...template, ...values };
        });
        forward();
      }}
    >
      {({ values, setFieldValue }) => (
        <StyledForm name="inspection_template_unit_type">
          <StyledInner>
            <H2 contentKey="landlordPortal.inspections.selectUnitType" centered />
            <StyledCardsContainer>
              <MediaQuery query="(max-device-width: 750px)">
                <StyledSelect
                  showSearch
                  name="unit_type_id"
                  placeholder={getTranslatedString('showingDrawer.select')}
                  size="large"
                  value={values.unit_type}
                  onChange={(value) => setFieldValue('unit_type', value)}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {unitTypesContentKeys.map((contentKey, i) => (
                    <Select.Option value={i} key={`templateTypeCardMobile-${contentKey}`}>
                      {getTranslatedString(contentKey)}
                    </Select.Option>
                  ))}
                </StyledSelect>
              </MediaQuery>
              <MediaQuery query="(min-device-width: 751px)">
                <RadioCards
                  name="unit_type_id"
                  setFieldValue={setFieldValue}
                  value={values.unit_type}
                >
                  {unitTypesContentKeys.map((contentKey, i) => (
                    <TemplateTypeCard
                      value={i}
                      key={`templateTypeCard-${contentKey}`}
                      bodyText={contentKey}
                    />
                  ))}
                </RadioCards>
              </MediaQuery>
            </StyledCardsContainer>
            <ButtonPrimary
              disabled={isNaN(values.unit_type)}
              contentKey="landlordPortal.inspections.next"
            />
          </StyledInner>
        </StyledForm>
      )}
    </Formik>
  );
};
